// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"xR y1","whiteTheme":"xS","markdownWrapper":"xT"};